import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 0 5px;
  text-align: center;
  span {
    color: ${(props) => props.theme.colors.green};
    font-size: 24px;
    font-weight: 900;
    flex: 1;
  }
`;
